<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 21 21"
			:fill="color"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.5846 2.52668C13.4271 3.38978 11.1164 3.95144 8.70413 4.15958C8.00883 4.21958 7.30496 4.25021 6.59375 4.25021H5.8125C2.79219 4.25021 0.34375 6.69865 0.34375 9.71896C0.34375 12.4269 2.31192 14.6751 4.8958 15.1112C5.244 16.5373 5.72714 17.9104 6.33088 19.2163C6.81428 20.2618 8.0748 20.5913 9.02114 20.0449L9.7048 19.6502C10.6216 19.1209 10.919 17.9912 10.509 17.0793C10.2644 16.5351 10.0461 15.9766 9.85565 15.4054C11.8529 15.6742 13.7728 16.1864 15.5846 16.9112C16.3405 14.6515 16.75 12.233 16.75 9.71894C16.75 7.20486 16.3405 4.78642 15.5846 2.52668Z"
				:fill="color"
			/>
			<path
				d="M17.0215 1.89677C17.8584 4.35063 18.3125 6.98176 18.3125 9.71894C18.3125 12.4561 17.8584 15.0873 17.0215 17.5411C16.964 17.7096 16.9049 17.8774 16.8439 18.0442C16.6956 18.4493 16.9038 18.898 17.309 19.0464C17.7142 19.1947 18.1628 18.9864 18.3112 18.5813C18.457 18.1828 18.5933 17.7798 18.7198 17.3724C19.2653 15.6154 19.6278 13.7782 19.7854 11.8833C20.3239 11.3224 20.6562 10.5592 20.6562 9.71896C20.6562 8.8787 20.3239 8.11553 19.7854 7.55465C19.6278 5.65977 19.2653 3.82257 18.7198 2.06554C18.5933 1.65816 18.457 1.25511 18.3112 0.856664C18.1628 0.451484 17.7142 0.243253 17.309 0.391569C16.9038 0.539884 16.6956 0.988581 16.8439 1.39376C16.9049 1.56055 16.964 1.72829 17.0215 1.89677Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMegaphone',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>